<script>
import { parseOptionsMethods } from '@state/helpers'
import _ from 'lodash'

export default {
  props: {
    parseOption: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ...this.parseOption,
      delimiterRules: [v => !!v || 'Delimiter is required'],
    }
  },
  computed: {
    placeholders() {
      return {
        delimiter: ',',
      }
    },
  },
  created() {
    this.originalParseOption = {
      delimiter: this.parseOption.delimiter,
      ignoreQuotes: this.parseOption.ignoreQuotes,
      trim: this.parseOption.trim,
    }

    this.tryUpdateOption = _.debounce(this.tryUpdateOption, 500)
  },
  methods: {
    ...parseOptionsMethods,
    tryUpdateOption() {
      var vm = this
      var updatedOption = this.parseOption
      updatedOption.delimiter = this.delimiter
      updatedOption.ignoreQuotes = this.ignoreQuotes
      updatedOption.trim = this.trim

      return this.updateOption(updatedOption)
        .then(updated => {
          vm.delimiter = updated.delimiter
          vm.ignoreQuotes = updated.ignoreQuotes
          vm.trim = updated.trim

          vm.originalParseOption = updated
        })
        .catch(error => {
          this.updateError = error

          vm.delimiter = vm.originalParseOption.delimiter
          vm.ignoreQuotes = vm.originalParseOption.ignoreQuotes
          vm.trim = vm.originalParseOption.trim
        })
    },
    updateDelimiter() {
      if (this.delimiter && this.delimiter.length > 1) {
        this.delimiter = this.delimiter[0]
      }
      if (!this.delimiter) {
        return
      }

      return this.tryUpdateOption()
    },
    updateQuotes(checked) {
      return this.tryUpdateOption()
    },
    updateTrim(checked) {
      return this.tryUpdateOption()
    },
  },
}
</script>

<template>
  <tr :data-id="parseOption.id">
    <td colspan="2">{{ forType }}</td>
    <td colspan="2">
      <v-text-field
        v-model="delimiter"
        class="delimiter"
        color="cyan"
        :placeholder="placeholders.delimiter"
        :rules="delimiterRules"
        @input="updateDelimiter"
      />
    </td>
    <td colspan="2">
      <v-checkbox
        v-model="ignoreQuotes"
        class="ignoreQuotes"
        type="checkbox"
        color="cyan"
        @change="updateQuotes"
      />
    </td>
    <td colspan="2">
      <v-checkbox
        v-model="trim"
        class="trim"
        type="checkbox"
        color="cyan"
        @change="updateTrim"
      />
    </td>
  </tr>
</template>

<style lang="scss" module>
@import '@design';
</style>
